/* eslint-disable import/prefer-default-export */
import { RootState } from 'store';
import { SavedCompListItem } from 'types/comparableContracts';

export const selectComparableContractsLists = (state: RootState): SavedCompListItem[] =>
  state.comparableContracts.compLists;
